import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { DirectivesModule } from "../../directives/directives.module";
import { PipesModule } from "../../pipes/pipes.module";
import { SimpleDialogComponent } from "./simple-dialog.component";

@NgModule({
  declarations: [SimpleDialogComponent],
  imports: [CoreModule, DirectivesModule, PipesModule],
  exports: [SimpleDialogComponent],
})
export class SimpleDialogModule {}
